import type { IxcCostbasisV1RealizationKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const getCostBasisRealizationPath: EntityPathBuilder<IxcCostbasisV1RealizationKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      if (!context?.keys) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/asset/$assetId/realization', context.keys);
    case 'detail': {
      if (!context?.keys?.accountId || !context?.keys?.assetId || !context?.keys?.realizationId) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/asset/$assetId/realization/$realizationId', context.keys);
    }
  }
};

export function getCostBasisRealizationDetailPath(accountId: string | undefined, assetId: string | undefined, realizationId: string | undefined) {
  if (!accountId || !assetId || !realizationId) {
    return undefined;
  }

  return getCostBasisRealizationPath({ kind: 'detail', keys: { accountId, assetId, realizationId } });
}
